/**
 * The API is mounted under a versioned prefix. The web app reaches it on the same origin
 * (its Worker forwards `/api/*` to the API Worker via a service binding).
 */
export const API_PREFIX = '/api' as const;
export const API_VERSION = 'v1' as const;
export const API_BASE_PATH = `${API_PREFIX}/${API_VERSION}` as const;

export type ApiBasePath = typeof API_BASE_PATH;

/**
 * Header carrying the per-request correlation id on every API response.
 */
export const REQUEST_ID_HEADER = 'x-request-id' as const;
